var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userID),expression:"userID"}],ref:"calendar",staticClass:"flix-bookingCalendar",attrs:{"data-user":_vm.userID,"data-id":_vm.$route.params.id}},[_c('flixLoader')],1),(!_vm.userID)?_c('flixLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }